import { UpdateUserRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { LIST_TENANT_USERS_QUERY_KEY } from './useFetchTenantUsers';

export const useUpdateUser = ({ userId }: { userId: string }) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, isPending, error } = useMutation({
    mutationFn: (data: UpdateUserRequest) => api.users.updateUser(tenantId, userId, data),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [LIST_TENANT_USERS_QUERY_KEY], exact: false });
    },
  });

  return {
    updateUser: mutate,
    isUpdating: isPending,
    updateError: error as AxiosError<{ message: string }>,
  };
};
